// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'
import barba from './barba/barba-init';
import menu from './modules/menu';
import clock from './modules/clock';
import scrollSection from './modules/scroll-section';
import navScroll from './modules/navscroll';
import projectMenu from './modules/project-menu';
import {startScroll, stopScroll} from './modules/scroll-ease';
import subscribeText from './modules/footer';
import setnav from './modules/setnav';

$(document).ready(function(){

  menu();
  clock();
  navScroll();
  scrollSection();
  startScroll();

  //Move project load to project views
  projectMenu();
  barba();

  subscribeText();

  var ios = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

  if(ios == true) {
    $('body').addClass('ios-device');
  }




});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js